<!-- 지역관리 지역 추가/수정 -->
<template>
  <div>
    <product-list @productItems="productItems" page="exhibition" style="zoom: 0.85"></product-list>
  </div>
</template>

<script>
  import ProductList from "../../page/product/ProductList";

  export default {
    props: ['data'],
    components: {
      ProductList
    },
    data() {
      return {
        value: {
          productIdArr: [],
          productTable: []
        }
      }
    },
    computed: {},
    created() {
      this.value = this.data;
    },
    watch: {
      data(n) {
        if (n) {
          this.value = n;
        }
      }
    },
    methods: {
      cancelModal() {
        this.$store.commit('cancelModal');
      },
      // 상품 정보 리스트
      productItems(res){
        for(let i=0; i<res.id_list.length; i++){
          if(this.value.productIdArr.includes(res.id_list[i])===false){
            this.value.productIdArr.push(res.id_list[i]);
            this.value.productTable.push(res.productItems[i]);
          }
        }
        // 팝업닫기
        this.$store.commit('closeModal', this.value);
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
</style>
